export enum RateTypeEnum {
    NORMAL = 'normal',
    SOCIAL = 'social',
    FAMILY = 'family',
}
